/** The file types the upload screen takes, defined once.
 *
 * The picker's `accept` attribute and the chips under the drop zone are both derived from this list,
 * so a type added here appears in both and a type cannot be offered by one and refused by the other.
 * The server is still the authority: `evidence/validate` sniffs the content and refuses a file that
 * is not what its name claims, whatever this list says (it is the browser's hint, not a check).
 *
 * A spreadsheet is imported rather than read as a document, which the library card says; the chip
 * names the format and not the route.
 */

export interface UploadType {
  /** Extensions the picker offers, with the dot. */
  extensions: readonly string[];
  /** The chip's word. */
  label: string;
}

export const UPLOAD_TYPES: readonly UploadType[] = [
  { extensions: [".pdf"], label: "PDF" },
  { extensions: [".csv"], label: "CSV" },
  { extensions: [".xlsx"], label: "Excel" },
  { extensions: [".png", ".jpg", ".jpeg", ".tif", ".tiff"], label: "Photo of a statement" },
];

/** The `accept` attribute: every extension above, comma separated. */
export const ACCEPT_ATTRIBUTE: string = UPLOAD_TYPES.flatMap((type) => type.extensions).join(",");
